import { AbstractControl, ValidationErrors } from "@angular/forms";

const CNPJ_LENGTH = 14;
const CNPJ_BASE_LENGTH = 12;
const CNPJ_INVALID_ERROR: ValidationErrors = { validaCNPJ: { valid: false } };
const FIRST_CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const SECOND_CHECK_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function validaCNPJ(c: AbstractControl): ValidationErrors | null {
  const cnpjOriginal = c.value;
  const cnpjFormatado = cnpjOriginal == null ? "" : String(cnpjOriginal).trim();
  const cnpj = cnpjFormatado.replace(/[.\-\/\s]/g, "").toUpperCase();

  const invalid = (
    ponto: string,
    detalhes: Record<string, unknown> = {}
  ): ValidationErrors => {
    // console.warn("[validaCNPJ] CNPJ inválido", {
    //   ponto,
    //   cnpjOriginal,
    //   cnpjSanitizado: cnpj,
    //   ...detalhes,
    // });

    return CNPJ_INVALID_ERROR;
  };

  if (!cnpjFormatado) {
    return invalid("valor vazio ou não informado");
  }

  const caracteresInvalidos = cnpj
    .split("")
    .map((caractere, index) => ({ caractere, posicao: index + 1 }))
    .filter(({ caractere }) => !/^[A-Z0-9]$/.test(caractere));

  if (caracteresInvalidos.length) {
    return invalid("caractere inválido", { caracteresInvalidos });
  }

  if (cnpj.length !== CNPJ_LENGTH) {
    return invalid("quantidade de caracteres diferente de 14", {
      tamanhoAtual: cnpj.length,
      tamanhoEsperado: CNPJ_LENGTH,
    });
  }

  const base = cnpj.substring(0, CNPJ_BASE_LENGTH);
  const digitos = cnpj.substring(CNPJ_BASE_LENGTH);

  if (!/^[A-Z0-9]{12}$/.test(base)) {
    return invalid("base do CNPJ fora do padrão alfanumérico", {
      base,
      formatoEsperado: "12 caracteres alfanuméricos",
    });
  }

  if (!/^\d{2}$/.test(digitos)) {
    return invalid("dígitos verificadores devem ser numéricos", {
      digitosInformados: digitos,
    });
  }

  if (/^(\d)\1{13}$/.test(cnpj)) {
    return invalid("sequência numérica repetida inválida");
  }

  const charToValue = (char: string): number => char.charCodeAt(0) - 48;

  const calcularDigito = (valorBase: string, pesos: number[]): number => {
    let soma = 0;

    for (let i = 0; i < pesos.length; i++) {
      soma += charToValue(valorBase[i]) * pesos[i];
    }

    const resto = soma % 11;

    return resto < 2 ? 0 : 11 - resto;
  };

  const digito1 = calcularDigito(base, FIRST_CHECK_DIGIT_WEIGHTS);

  if (digito1 !== parseInt(digitos[0], 10)) {
    return invalid("primeiro dígito verificador inválido", {
      digitoInformado: digitos[0],
      digitoEsperado: digito1,
    });
  }

  const digito2 = calcularDigito(
    `${base}${digito1}`,
    SECOND_CHECK_DIGIT_WEIGHTS
  );

  if (digito2 !== parseInt(digitos[1], 10)) {
    return invalid("segundo dígito verificador inválido", {
      digitoInformado: digitos[1],
      digitoEsperado: digito2,
    });
  }

  return null;
}
